import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=7c563e38&"
import script from "../assets/js/caseList.js?vue&type=script&lang=js&"
export * from "../assets/js/caseList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports